import React, { useEffect, useRef, useState } from 'react'
import ItemForm from './itemsTab/index'
import HeaderForm from './headerTab/index'
import PartiesForm from './partiesTab/index'
import ErrorBoundary from './errorboundry'
import { getFormData, getDropdownValues, refreshIntialData } from '../api/getGBForm'
import get from 'lodash/get'
import NotesTab from './NotesTab'
import BillingForm from '../../commonComponents/commonBillingTab/index'
import { useDispatch, useSelector } from 'react-redux'
import { Tab, TabItem } from '../../commonComponents/formComponents/Tab'
import ShipmentInfoProvider from '../../context/shipmentInfo.js/index.js'
import { initializeDropDownValues, clearDropdown } from '../../commonActions/DropDownActions'
import { CustomLoader } from '../../commonComponents/formComponents/loader'
import { ErrorMessage } from '../../commonComponents/formComponents/ErrorMessage'
import { initializeItemForm, initializeHeaderForm, clearForm } from '../actions'
import { initializeContainerForm } from '../../commonComponents/ContainerTab/actions/containerAction'
import { initializeValueBuildUpForm } from '../actions/ValueBuildUpAction'
import ContainerForm from './containersTab'
import ValueBuildUpTab from './valueBuildUpTab'
import { SAVE_FORM_CDS, DELETE_ENTITY_CDS } from '../api/apiEvents'
import { InitializePartiesForm } from '../actions'
import TranslateContextProvider from '../../NL_App/formSections/TranslateContext'
import { getJobWheels, isShipmentDisabled } from '../../util'
import { resetServerErrors } from '../../commonActions/serverErrorAction'
import {
  intializeHeaderTabWarnings,
  intializePartiesTabWarnings,
  intializeValueBuildUpTabWarnings,
  intializeContainerTabWarnings,
  intializeItemsTabWarnings,
} from '../actions/errorValidationActions'
import { Portal } from '../../commonComponents/portal'
import SendArrivalNoticeButton from '../../../header/ButtonMapper/sendArrivalNotice'
import RubberBindingInfoProvider from '../../context/rubberBindingInfoProvider'
import { canUserFile } from '../../util'
import axios from 'axios'
import { cdsFieldPatterns } from '../util/cdsFieldPattern'
import validate from 'validate.js'
import { createValidationStructure } from '../../Helper'
import DisplayError from '@commonComponents/displayError'
import { INIT_VALIDATION_ERRORS } from '../../commonActionTypes'
import { validateContainers, invoiceDataConversion } from '../util/cdsValidateFunctions'
import ActorProvider from './partiesTab/Actors/actorProvider'
import { validateInvoices } from '../../NL_App/util/itemsTabValidation'
import DisplayErrorServer from '../../commonComponents/DisplayErrorServer'

import {
  headerTabLinking,
  itemsTabLinking,
  partiesTabLinking,
} from '../../commonComponents/utils/errorMessageLink'
import { Button, Icon } from 'semantic-ui-react'
import CCSAirUK from '../ccsAir'

const GBForm = (props) => {
  const { serviceType } = props
  const [loader, setLoader] = useState(false)
  const [isLoading,setIsLoading] = useState(false)
  const [isInitialize,setIsInitialize] = useState(null)
  const [error, setError] = useState(false)
  const IsdrodpownAlreadyFilled = useRef(false)
  const jobWheels = getJobWheels(props.currentJobData)
  let currentJobState = jobWheels ? jobWheels['ES_ENTRY_JOB_WHEEL']?.value?.state : ''
  let customJobState = jobWheels ? jobWheels['GB_CUSTOM_JOB_WHEEL']?.value?.state : ''
  let brokerHouseState = jobWheels ? jobWheels['SHIPMENT_BROKER_HOUSE_PROCESS']?.value?.state : ''

  const isEntryInProcess = currentJobState?.includes('STATE_ENTRY_IN_PROCESS')
  const isPendingFilling = currentJobState?.includes('STATE_ENTRY_NONE')
  const serverErrorsCommon = useSelector((state) => state.serverErrorReducerCommon)
  const isServerErrorsCommon =
    serverErrorsCommon?.header?.length > 0 ||
    serverErrorsCommon?.parties?.length > 0 ||
    serverErrorsCommon?.items?.length > 0

  const handleErrorFocus = (tab, error) => {
    if (tab === 'header') headerTabLinking(error)
    if (tab === 'parties') partiesTabLinking(error)
    if (tab === 'items') itemsTabLinking(error)
  }

  const isMounted = useRef(false)
  const { declaration = '', declarationType = '' } = useSelector((state) => state.Shipment)

  const userGuid = props.kxUserBasicInfo?.userGuid
  const brokerGuid = props.currentJobData?.brokerGuid
  const badge = props.currentJobData?.badge || ''
  const canFile = canUserFile(props.kxUserBasicInfo, props?.kxEngineUserInfo)
  const isFormDisabled =
    userGuid !== brokerGuid ||
    !canFile ||
    isShipmentDisabled(currentJobState, customJobState, false, brokerHouseState)

  const dispatch = useDispatch()
  useEffect(() => {
    const source = axios.CancelToken.source()
    const intilizeDropDownCalls = async () => {
      try {
        const response = await getDropdownValues(
          serviceType == 'IM' ? 'IMPORT' : 'EXPORT',
          source.token
        ).catch((err) => console.log(err))
        dispatch(initializeDropDownValues(response.data.eventMessage))
      } catch (err) {}
    }
    intilizeDropDownCalls()

    return () => {
      source.cancel('Operation canceled by the user.')
      dispatch(clearDropdown())
    }
  }, [serviceType])
  useEffect(() => {
    const source = axios.CancelToken.source()
    const getData = async () => {
      setLoader(true)
      setError('')
      window.currentServicetype = serviceType //temporary disabled validations for export
      try {
        let response = await getFormData(props.shipId, source.token)
        isMounted.current = true
        const {
          data: {
            eventMessage: { parties, header, container, invoice, valueBuildUp },
          },
        } = response
        window.shipmentId = props.shipId
        dispatch(initializeContainerForm(container))
        dispatch(initializeValueBuildUpForm(valueBuildUp))
        dispatch(initializeHeaderForm(header))
        dispatch(InitializePartiesForm(parties))
        dispatch(initializeItemForm(invoice))
        dispatch(resetServerErrors())
        const isImportShipment = serviceType !== 'EX'

        if (!isImportShipment) {
          let headerTabError = validate(header, cdsFieldPatterns(isImportShipment)()?.header) || {}
          headerTabError = createValidationStructure(headerTabError)

          let partiesTabError =
            validate(parties, cdsFieldPatterns(isImportShipment)()?.parties) || {}
          partiesTabError = createValidationStructure(partiesTabError)

          let itemsTabErrors =
            validateInvoices(
              invoiceDataConversion(invoice),
              cdsFieldPatterns(isImportShipment)({ declarationCat: header.declarationCat })?.items
            ) || {}
          let containerErrors = validateContainers(
            container?.containerList,
            cdsFieldPatterns(isImportShipment)()?.containers
          )
          dispatch({
            type: INIT_VALIDATION_ERRORS,
            payload: {
              header: headerTabError,
              containers: containerErrors,
              parties: partiesTabError,
              items: itemsTabErrors,
            },
          })
        }

        if (header.declarationCat && serviceType === 'IM') {
          dispatch(
            intializeHeaderTabWarnings(
              'headerTab',
              response.data.eventMessage,
              header.declarationCat,
              badge
            )
          )
          dispatch(
            intializePartiesTabWarnings(
              'partiesTab',
              response.data.eventMessage,
              header.declarationCat
            )
          )
          dispatch(
            intializeValueBuildUpTabWarnings(
              'valueBuildUpTab',
              response.data.eventMessage,
              header.declarationCat
            )
          )
          dispatch(
            intializeContainerTabWarnings(
              'containersTab',
              response.data.eventMessage,
              header.declarationCat
            )
          )
          dispatch(
            intializeItemsTabWarnings('itemsTab', response.data.eventMessage, header.declarationCat)
          )
        }

        setLoader(false)
      } catch (e) {
        console.error(e)
        if (isMounted.current) {
          setLoader(false)
          setError(e)
        }
      }
    }
    getData()
    sessionStorage.removeItem('toggleInvoices')
    sessionStorage.removeItem('toggleLineItems')
    return () => {
      isMounted.current = false
      source.cancel('Operation canceled by the user.')
      dispatch(clearForm())
    }
  }, [props.shipId,isInitialize])


  const refreshgData = async() =>{
      setIsLoading(true)
    let response = await refreshIntialData(props.shipId)
    if(response){
         setIsInitialize(response?.data?.eventMessage)
         setIsLoading(false)
    }
  }

  const kxUserBasicInfo = get(props, 'kxUserBasicInfo', {})
  let content
  if (error) content = <ErrorMessage>An Error Occured In Loading GB Form</ErrorMessage>
  else if (loader) content = <CustomLoader>Preparing Form</CustomLoader>
  else if (isMounted.current) {
    content = (
      <ErrorBoundary>
        <div style={{ marginTop: '5px' }} className='tabContainer C88'>
          <TranslateContextProvider translate={props.translate}>
            <ShipmentInfoProvider
              shipmentId={props.shipId}
              deleteEvent={DELETE_ENTITY_CDS}
              saveEvent={SAVE_FORM_CDS}
              serviceType={serviceType}
              isDisabled={isFormDisabled}
              currentJobState={currentJobState}
              kxEngineUserInfo={props?.kxEngineUserInfo}
            >
              <RubberBindingInfoProvider rubberBindingInfo={props.rubberBindingInfo}>
                <ActorProvider>
                  {declaration === 'IM' &&
                    ['D', 'E', 'F', 'K'].includes(declarationType) &&
                    !props.currentJobData.badge && (
                      <Portal targetElementId='sendArrival-notice-button'>
                        <SendArrivalNoticeButton shipId={props.shipId} lowerEnv={props.headerProps?.lowerEnv} />
                      </Portal>
                    )}

                  {(isEntryInProcess ||  isPendingFilling) && (
                    <Portal targetElementId='refreshData'>
                      <div className='exchangeRates'>
                        <Button
                          size='mini'
                          className='sv todo-button'
                          onClick={refreshgData}
                        >
                          <Icon
                            name="refresh"
                            style={{ color: "#267678", fontSize: "13px" }}
                          />
                    {isLoading ? "PROCESSING..." : "REFRESH DATA"}
                        </Button>
                      </div>
                    
                    </Portal>
                  )}

                  {/* {serverErrors && <ValidateError serverErrors={serverErrors} />} */}
                  {isServerErrorsCommon && (
                    <DisplayErrorServer
                      serverErrors={serverErrorsCommon}
                      // serverErrors={errorData?.eventMessage}
                      handleErrorFocus={handleErrorFocus}
                    />
                  )}

                  <Tab className='euForm' translate={props.translate}>
                    <TabItem id='headerTab' title='Header'>
                      {!isServerErrorsCommon && <DisplayError tabName='header' />}
                      <HeaderForm
                        isServerErrorsCommon={isServerErrorsCommon}
                        currentJobState={currentJobState}
                        {...props}
                      />
                    </TabItem>
                    <TabItem id='partiesTab' title='Parties'>
                      {!isServerErrorsCommon && <DisplayError tabName='parties' />}
                      <PartiesForm isServerErrorsCommon={isServerErrorsCommon} {...props} />
                    </TabItem>
                    {serviceType === 'IM' && (
                      <TabItem id='valueBuildUpTab' title='VALUE BUILD UP'>
                        <ValueBuildUpTab {...props} />
                      </TabItem>
                    )}
                    <TabItem id='itemsTab' title='Items'>
                      {!isServerErrorsCommon && <DisplayError tabName='items' />}
                      <ItemForm isServerErrorsCommon={isServerErrorsCommon} {...props} />
                    </TabItem>
                    <TabItem id='containersTab' title='Containers'>
                      <DisplayError tabName='containers' />
                      <ContainerForm />
                    </TabItem>
                    <TabItem id='notesTab' title='Notes'>
                      <NotesTab
                        kxUserBasicInfo={kxUserBasicInfo}
                        isFormEnabled={!isFormDisabled}
                        shipId={props.shipId}
                        fullName={get(kxUserBasicInfo, 'fullName', '')}
                        translate={props.translate}
                      ></NotesTab>
                    </TabItem>
                    {props?.kxEngineUserInfo?.isEngineUser != "true" && <TabItem id='billingTab' title='Billing'>
                      <BillingForm isDisabled={isFormDisabled} {...props} />
                    </TabItem>}
                  </Tab>
                </ActorProvider>
              </RubberBindingInfoProvider>
            </ShipmentInfoProvider>
          </TranslateContextProvider>
        </div>
        <div className='toast'></div>
        <CCSAirUK />
      </ErrorBoundary>
    )
  } else {
    return null
  }
  return content
}
export default React.memo(GBForm)
